import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cfe3702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "digital-block" }
const _hoisted_2 = { class: "digital-block__subtitle" }
const _hoisted_3 = { class: "digital-block__text" }

import pInput from '@/common/pInput/pInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DigitalBlock',
  props: {
  first: {
    type: String,
    required: true,
  },
  second: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  orText: {
    type: String,
    required: true,
  },
  firstPlaceholder: {
    type: String,
    default: '',
  },
  secondPlaceholder: {
    type: String,
    default: '',
  },
},
  emits: ["update:first", "update:second"],
  setup(__props, { emit: __emit }) {

const emit = __emit



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */),
    _createVNode(pInput, {
      value: __props.first,
      placeholder: __props.firstPlaceholder,
      type: "number",
      onInput: _cache[0] || (_cache[0] = (event) => emit('update:first', event.target.value))
    }, null, 8 /* PROPS */, ["value", "placeholder"]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.orText), 1 /* TEXT */),
    _createVNode(pInput, {
      value: __props.second,
      placeholder: __props.secondPlaceholder,
      type: "number",
      onInput: _cache[1] || (_cache[1] = (event) => emit('update:second', event.target.value))
    }, null, 8 /* PROPS */, ["value", "placeholder"])
  ]))
}
}

})